import {AxiosResponse} from 'axios';
import {pathOr, compose} from 'ramda';

import {CATEGORY, QUOTE_ITEM, PRODUCT} from 'constants/actions';

import {HtoSettingsType} from './settingsType';

export const initialState = {
    multifocal: {hto_period: 0, limit_order_items: 0},
    single_vision: {hto_period: 0, limit_order_items: 0},
};

const transformHtoData = htoSettings => ({
    multifocal: {
        hto_period: pathOr(0, ['multifocal', 'htoPeriod'], htoSettings),
        limit_order_items: pathOr(0, ['multifocal', 'limitOrderItems'], htoSettings),
    },
    single_vision: {
        hto_period: pathOr(0, ['singleVision', 'htoPeriod'], htoSettings),
        limit_order_items: pathOr(0, ['singleVision', 'limitOrderItems'], htoSettings),
    },
});

/**
 * Get HTO settings
 * @param {HtoSettingsType} state - current state
 * @param {ActionType<AxiosPromise>} action - action
 * @returns {HtoSettingsType|{}} - new state
 */
export default function settings(
    state: HtoSettingsType = initialState,
    action: {type: string; payload: AxiosResponse},
): HtoSettingsType | {} {
    switch (action.type) {
        case `${CATEGORY.GET_CATEGORY}_FULFILLED`:
        case `${QUOTE_ITEM.GET_ITEMS}_FULFILLED`:
        case 'GET_PRODUCT_DATA_CONFIGURE_FULFILLED':
            return {...state, ...pathOr({}, ['payload', 'data', 'hto', 'settings'], action)};
        case `${CATEGORY.GET_CATEGORY_ITEMS}_FULFILLED`:
        case `${PRODUCT.GET_PRODUCT}_FULFILLED`:
            return {
                ...state,
                ...compose(
                    transformHtoData,
                    pathOr({}, ['payload', 'data', 'htoSettings']),
                )(action),
            };
        default:
            return state;
    }
}
